import React from 'react'

const Links = () => {
  return (
    <div className="contact-links">
      <a href="https://www.linkedin.com/in/louis-klein-audio/" target="_blank" rel="noreferrer" className='contact-link'>LinkedIn</a>
      <a href="https://github.com/lzklein" target="_blank" rel="noreferrer" className='contact-link'>GitHub</a>
      {/* <a href="mailto:louisklein71@gmail.com" target="_blank" rel="noreferrer" className='contact-link'>Email</a> */}
    </div>
  )
}

export default Links